import React from "react";
import { _goToItsaWebSite } from "router/helper";

import { View, TouchableOpacity } from "react-native";
import { Text } from "component";

import { sizes, colors, strings, VERSION } from "asset/constant";
import { css } from "style";
import { mq } from "utils";

export default function ItsaLink() {
  return (
    <View style={{ marginBottom: 15 }}>
      <Text size={"xs"} align="center">
        {strings.app_name} {VERSION.NAME}
      </Text>

      <View
        style={{
          ...css.rRowCenterAlign,
          ...css.centralElements,
          paddingHorizontal: mq(5),
        }}
      >
        <TouchableOpacity
          onPress={() => {
            setTimeout(_goToItsaWebSite, 500);
          }}
          activeOpacity={sizes.tapOpacity}
          style={{
            ...css.selfCenter,
            ...css.rowCenterAlign,
            marginVertical: 5,
          }}
        >
          <Text size={"xs"} color={colors.info}>
            {" "}
            {strings.itsa}
          </Text>
          <Text size={"xs"}> {strings.developed_by}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}
